export const domain = "https://api.askreceivegive.com"
//https://api.askreceivegive.com/